import React from 'react';
import { useWebSocket } from '../../contexts/WebSocketContext';

export default function Notification() {
  const { notifications, removeNotification } = useWebSocket();

  if (notifications.length === 0) return null;

  return (
    <div className="fixed top-20 right-4 z-50 space-y-3 max-w-md">
      {notifications.map((notification) => (
        <div
          key={notification.id}
          className="bg-white border-l-4 border-primary shadow-lg rounded-lg p-4 flex items-start gap-3 animate-slide-in"
        >
          {/* Icon */}
          <div className="flex-shrink-0 text-2xl">
            {notification.type === 'score' && '⛳'}
            {notification.type === 'leaderboard' && '📊'}
            {notification.type === 'complete' && '🏆'}
            {notification.type === 'info' && 'ℹ️'}
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0">
            {notification.title && (
              <h4 className="text-base font-bold text-gray-900 mb-1">
                {notification.title}
              </h4>
            )}
            <p className="text-sm text-gray-700">{notification.message}</p>
            {notification.subtitle && (
              <p className="text-xs text-gray-500 mt-1">{notification.subtitle}</p>
            )}
          </div>

          {/* Close button */}
          <button
            onClick={() => removeNotification(notification.id)}
            className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>
      ))}
    </div>
  );
}
